var render = function render(){var _vm=this,_c=_vm._self._c;return _c('figure',{staticClass:"broker-logo"},[_c('img',{attrs:{"src":_vm.brokerLogo}})])
}
var staticRenderFns = []

export { render, staticRenderFns }